import * as React from 'react';
import { ITicketSelection, OfferType, RateChange } from 'eTip--common';
import { numberFormatter, translationForMts } from 'easit--localization';
import { } from 'easit--routing'
import { useState, useEffect } from 'react';
import * as classNames from 'classnames';

export interface ITicketSelectionProps {
    tip: ITicketSelection;
    changeIsBanker?: (selection: ITicketSelection, value: boolean) => void;
    removeTip: (ident: string) => void;
    isEnabledUI: boolean;
    errors: string[];
    canShowBanker: boolean;
    canShowAliasNumber: boolean;
    isForOneTapBet: boolean;
    goToDetail: () => void;
}

function usePrevious(value: any) {
    const ref = React.useRef();
    useEffect(() => {
        ref.current = value;
    }, [value]); // Only re-run if value changes

    return ref.current;
}

/**
 * ! All parents have to use observer or incoming array should be [...array] copied.
 *
 */
export const TicketSelection: React.FC<ITicketSelectionProps> = (props) => {
    const { tip: { isBanker, fixtureName, marketName, tipName, rate, indent } } = props;

    //!! similar in EventRate.tsx, ticketTip.tsx, eventRateComponent.tsx and EventRateChangeMonitoringWrapper as "generic"
    const [repeatChange, setRepeatChange] = useState<boolean>(false);
    const [changeClass, setChangeClass] = useState<string>('');
    const [lastChangeTime, setLastChangeTime] = useState<number>(0);
    const prevRate = usePrevious(props.tip.rate) || 0;

    const bankerClick = () => {
        if (props.isEnabledUI) {
            props.changeIsBanker(props.tip, !isBanker);
        }
    };

    useEffect(() => {
        if (prevRate && props.tip.rate) {
            let change = changeClass;
            const newTime = new Date().getTime();
            if (props.tip.rateChange === RateChange.ForceNone || ((!props.tip.rateChange || props.tip.rateChange === RateChange.None) && newTime > (lastChangeTime + 10000))) {
                if (change !== "") {
                    setChangeClass("");
                }
            } else {
                if (props.tip.rate != prevRate) { // to avoid repeating refresh
                    setLastChangeTime(newTime);
                    if (props.tip.rateChange === RateChange.Down) {
                        change = ' fa-caret-down';
                    } else if (props.tip.rateChange === RateChange.Up) {
                        change = ' fa-caret-up';
                    }

                    change += repeatChange ? ' blink-me-r' : ' blink-me';
                    setRepeatChange(!repeatChange);
                    setChangeClass(change);
                }
            }
        }
    }, [props.tip.rate, props.tip.rateChange]);

    let liveFlag = props.tip.offerType === OfferType.Live &&
        <span className={classNames("live-selection-flag", __IsMTSTipos__ ? "ml-1" : null)}>LIVE</span>;

    return <div className={classNames("ticket-selection-row", props.isForOneTapBet ? "otb-active-bordered no-margins" : "with-background", props.tip.canAnimate ? "just-added-tip" : null)} data-test-role="tips__item">
        <div className="flex-grow-1">
            <div className="d-flex justify-content-between align-items-center">
                <div>
                    <span className={classNames("event-name cursor-pointer", __IsMTSTipos__ ? "d-inline-block mb-2" : "font-weight-bold")} onClick={() => { props.goToDetail(); }}>
                        {fixtureName}
                        {
                            __IsMTSTipos__ && liveFlag
                        }
                    </span>
                    {
                        !__IsMTSTipos__ && liveFlag
                    }
                    <br />
                    <div className="game-name">
                        {props.canShowAliasNumber && `${props.tip.number} `}{marketName} <br />
                        {translationForMts().ticket_OddTitle}: <strong>{tipName}</strong>
                    </div>
                </div>
                <div className="tip-rate ml-auto text-right mr-2 d-flex align-items-center" onClick={props.canShowBanker ? bankerClick : undefined}>
                    <>
                        {
                            changeClass !== '' && <span className={`fa mr-1 ${changeClass}`}></span>
                        }
                        {numberFormatter.format(rate)}
                    </>
                    {
                        props.canShowBanker &&
                        <>
                            <br />
                            <span className={`banker cursor-pointer ${isBanker ? 'fa fa-star banker-selected' : 'far fa-star'}`}
                            /*onClick={bankerClick} it's on parent div for wider area*/
                            ></span>
                        </>
                    }
                </div>
                <i className={"fas fa-times m-2 remove-link"} onClick={() => { props.isEnabledUI && props.removeTip(indent) }}></i>
            </div>
            {
                props.errors && props.errors.length > 0 &&
                <div>
                    {
                        props.errors.map((error, idx) => <div key={idx} className="tip-error">{error}</div>)
                    }
                </div>
            }
        </div>
    </div >
};